import { Integration } from '../models';
import IntegrationService from '../services/IntegrationService';

export interface IntegrationState {
  integrations: Integration[];
  integration: Integration;
  loading: boolean;
}

export const IntegrationModule = {
  state: {
    integrations: [],
    integration: null as any,
    loading: false,
  },
  mutations: {
    setIntegrationLoading(state: IntegrationState, loading: boolean) {
      state.loading = loading;
    },
    setIntegrations(state: IntegrationState, integrations: Integration[]) {
      state.integrations = integrations;
    },
    setIntegration(state: IntegrationState, integration: Integration) {
      state.integration = integration;
    },
  },
  actions: {
    async loadIntegrations({ commit }: any) {
      const integrations: Integration[] = await IntegrationService.getAllIntegrations();
      commit('setIntegrations', integrations);
      return integrations;
    },
    async loadIntegrationByPlatform({ commit }: any, { platform }: { platform: string }) {
      IntegrationService.getAllIntegrationsByPlatform(platform).then((res: Integration) => {
        commit('setIntegration', res);
      });
    },
  },
};
